import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {ObjectBaseModeComponent} from "../../../../../../core/shared/object/mvs-object-base/object-base-mode.component";
import {NavigationItem} from "../../../../../../core/shared/dto/navigation/navigation-item";

@Component({
    selector: 'bm-dunning-type-trigger-base',
    template: '',
    standalone: false
})
export class BmDunningTypeTriggerBaseComponent extends ObjectBaseModeComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    navigationItems: NavigationItem[] = [
        {
            label: 'dunningTypeTrigger',
            action: 'dunningTypeTrigger',
            tooltip: 'Dunning Type Trigger',
            icon: 'fa-solid fa-regular fa-layer-group', // Represents scheduling/calendar
            toggleable: false,
            default: true
        },
        {
            label: 'dunningTypeTriggerLogicField',
            action: 'dunningTypeTriggerLogicField',
            tooltip: 'Dunning Type Trigger Logic Field',
            icon: 'fa-solid fa-regular fa-arrow-up-right-dots', // Represents a group/team with settings
            toggleable: false,
            default: false
        },
        {
            label: 'dunningTypeLevelTriggerLogicField',
            action: 'dunningTypeLevelTriggerLogicField',
            tooltip: 'Dunning Type Level Trigger Logic Field',
            icon: 'fa-solid fa-regular fa-arrow-up-right-dots', // Represents a group/team with settings
            toggleable: false,
            default: false
        }
    ];

    constructor(protected route: ActivatedRoute) {
        super(route)
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
